/**
 *  Use role for following
 *
 *  VLE_TEACHER: "VLE_TEACHER",
 *  VLE_STUDENT: "VLE_STUDENT",
 *  CCPM_APPROVER: "CCPM_APPROVER",
 *  CCPM_OFFICER: "CCPM_OFFICER",
 *  SCHOOL_ADMIN: "SCHOOL_ADMIN",
 *  HELPDESK_ADMIN: "HELPDESK_ADMIN",
 *  ALP_ADMIN: "ALP_ADMIN",
 *  COMMUNITY_GALLERY_ADMIN: "COMMUNITY_GALLERY_ADMIN",
 */
export default {
  ACCOUNT_SETUP: "ACCOUNT_SETUP",
  FORCE_CHANGE_PASS: "FORCE_CHANGE_PASS",
  EXPIRED_USER_PASS: "EXPIRED_USER_PASS",
  AUDIT_RULE_REVIEW_USER: "AUDIT_RULE_REVIEW_USER",
  REQUIRED_ACKNOWLEDGE_ADVISORY_NOTE: "REQUIRED_ACKNOWLEDGE_ADVISORY_NOTE",
  OTP_LOGIN: "OTP_LOGIN",
};
